import type {ReferralLinkConfigEntityType} from './types';

export const referralLinkConfigEntityType: ReferralLinkConfigEntityType = 'ReferralLinkConfig';

export const ReferralLinkConfigServiceTypes = {
    service: Symbol.for('ReferralLinkConfigService'),
    epicsBuilder: Symbol.for('ReferralLinkConfigEpicsBuilder'),
} as const;

export const ReferralLinkConfigTypeName = 'ReferralLinkConfig';
export const ReferralLinkConfigViewModelTypeName = 'ReferralLinkConfigViewModel';
export const ReferralLinkConfigViewModelKeysTypeName = 'ReferralLinkConfigViewModelKeys';
export const ReferralLinkConfigQueryFieldsTypeName = 'ReferralLinkConfigQueryFields';
export const ReferralLinkConfigSortKeysTypeName = 'ReferralLinkConfigSortKeys';
